export default __webpack_public_path__ + "static/media/solidarity.aae29920.svg";